module.exports = __webpack_public_path__ + "4aac80ff62f21f02e8c4cdaf46d1e4ee.png";


//////////////////
// WEBPACK FOOTER
// ./lib/provider/resources/img/logo-actradis.png
// module id = 1827
// module chunks = 0